import { useEffect, useState } from 'react';
import { client } from '../lib/sanity';
import EventRow from '../components/EventRow';

const EVENTS_QUERY = `*[_type == "event" && defined(startsAt) && coalesce(endsAt, startsAt) >= now()]
   | order(startsAt asc) {
     _id, title, "slug": slug.current, startsAt, endsAt, location,
     price, currency, ticketUrl, ticketLabel, soldOut, description, images
   }`;

function Events() {
  const [events, setEvents] = useState(null);
  const [openSlug, setOpenSlug] = useState(
    () => decodeURIComponent(window.location.hash.slice(1)) || null
  );

  useEffect(() => {
    client.fetch(EVENTS_QUERY).then(setEvents);
  }, []);

  // Someone arriving on /events#some-event should land on that event, opened.
  useEffect(() => {
    if (!events || !openSlug) return;
    document.getElementById(openSlug)?.scrollIntoView({ block: 'start' });
    // Only on first load of the list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const toggle = (slug) => {
    const next = openSlug === slug ? null : slug;
    setOpenSlug(next);
    window.history.replaceState(null, '', next ? `#${next}` : window.location.pathname);
  };

  return (
    <section className="events-section">
      <h1 className="events-heading">Events</h1>
      <p className="events-intro">
        Workshops and gatherings where we make things together. Pick one to see
        what it is about and how to join.
      </p>

      {events === null && <p className="events-empty">Loading events…</p>}

      {events !== null && events.length === 0 && (
        <p className="events-empty">
          No events planned right now — new dates are added here as soon as they
          are set.
        </p>
      )}

      {events !== null && events.length > 0 && (
        <div className="events-list">
          {events.map((event) => (
            <EventRow
              key={event._id}
              event={event}
              isOpen={openSlug === event.slug}
              onToggle={() => toggle(event.slug)}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default Events;
